import TextSizePicker from './TextSizePicker';

const ThemeRoute = () => <TextSizePicker />;

export default ThemeRoute;
